"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.BtuPerHourPerFeetPerFahrenheit = exports.WattPerMeterPerKelvin = void 0;
var uom_1 = require("uom");
// Thermal conductivity
exports.WattPerMeterPerKelvin = uom_1.UnitFormat.createUnitFormat("W/m/°K", 2);
exports.BtuPerHourPerFeetPerFahrenheit = uom_1.UnitFormat.createUnitFormat("BTU/h/ft/°F", 2);
//# sourceMappingURL=thermal-conductivity-format.js.map